import React from "react"
import IosRefresh from "react-ionicons/lib/IosRefresh"

const defaultColor = "#ccc"
const defaultFontSize = "48px"

export default ({color, fontSize}) => (
	<div className="loading-spinner"><IosRefresh color={color || defaultColor} fontSize={fontSize || defaultFontSize} rotate={true}/></div>
)